module.exports = __webpack_public_path__ + "static/media/Buddy.210bab5d.png";